import styled from 'styled-components'

export const FormContainer = styled.form``

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  justify-content: center;
  position: relative;
`
export const Text = styled.div`
  color: ${props => props.theme.colors.black};
  font-family: 'Raleway', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  font-size: 20px;
`

export const Label = styled.label`
  color: ${props => props.theme.colors.black};
  font-family: 'Raleway', sans-serif;
  display: flex;
  align-items: center;
  margin-right: 10px;
`

export const FormInput = styled.input`
  padding: 5px;
  border: 1px solid ${props => props.theme.colors.primary};
  border-radius: 4px;
`

export const FormTextArea = styled.textarea`
  padding: 5px;
  border: 1px solid ${props => props.theme.colors.primary};
  border-radius: 4px;
  width: 40vw;
  height: 15vh;
`

export const ErrorText = styled.span`
  color: #ff0033;
  position: absolute;
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  bottom: -18px;
`

export const FormSelectExam = styled.div`
  display: flex;
  input {
    margin-right: 5px;
  }
`

export const FormSelectCheckbox = styled.div``

export const FormCheckbox = styled.input`
  margin-right: 10px;
`

export const FormRadio = styled.input`
  margin-right: 10px;
`

export const FormText = styled.div`
  color: ${props => props.theme.colors.black};
  font-family: 'Raleway', sans-serif;
  width: 50%;
`

export const FormSubtitle = styled.div`
  color: ${props => props.theme.colors.black};
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  font-size: 16px;
`

export const RadioContainer = styled.div``

export const RadioRow = styled.div`
  display: flex;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 25px;
`
